<po-page-default
  [p-breadcrumb]="breadcrumb"
  p-title="Romaneio Cliente MI - {{romaneioCliente.CZ00STATUSDESC}}"
  [p-actions]=actions
>

  <div class="po-row">
    <po-widget
      class="po-md-12"
      (p-setting)="clickInformacoes()"
      p-title="Informações do Romaneio"
    >
      @if( apareceInformacoes ) {
        <div>
          <po-info class="po-md-3" p-label="Código" [p-value]="romaneioCliente.CZ00COD"></po-info>
          <po-info class="po-md-3" p-label="Status" [p-value]="romaneioCliente.CZ00STATUSDESC"></po-info>
          <po-info class="po-md-3" p-label="Usuário" [p-value]="romaneioCliente.CZ00USER"></po-info>
          <po-info class="po-md-3" p-label="Nome Usuário" [p-value]="romaneioCliente.CUSRNOME"></po-info>
          <po-info class="po-md-3" p-label="Grupo" [p-value]="romaneioCliente.CZ00GRPVEN"></po-info>
          <po-info class="po-md-3" p-label="Descrição do Grupo" [p-value]="romaneioCliente.CACYDESCRI"></po-info>
          <po-info class="po-md-3" p-label="Cliente" [p-value]="romaneioCliente.CZ00CLIENT"></po-info>
          <po-info class="po-md-3" p-label="Loja" [p-value]="romaneioCliente.CZ00LOJA"></po-info>

          <po-divider class="po-md-12" p-label="1ª Etapa"></po-divider>

          <po-info class="po-md-3" p-label="Process" [p-value]="romaneioCliente.CZ00PROCES"></po-info>
          <po-info class="po-md-3" p-label="N° Certificado" [p-value]="romaneioCliente.CZ00NCERT"></po-info>
          <po-info class="po-md-3" p-label="Truck Company" [p-value]="romaneioCliente.CZ00CAMICP"></po-info>

          <po-divider class="po-md-12" p-label="2ª Etapa"></po-divider>

          <po-info class="po-md-3" p-label="Container" [p-value]="romaneioCliente.CZ00COTNER"></po-info>
          <po-info class="po-md-3" p-label="Peso Limite" p-value="{{ romaneioCliente.NZ00PESLIM| number: '1.3-3' }}"></po-info>
          <po-info class="po-md-3" p-label="Shipping Company" [p-value]="romaneioCliente.CZ00FRETCP"></po-info>
          <po-info class="po-md-3" p-label="Tara" p-value="{{ romaneioCliente.NZ00TARA| number: '1.3-3' }}"></po-info>
          <po-info class="po-md-3" p-label="Definitive Seal" [p-value]="romaneioCliente.CZ00SELOD"></po-info>
          <po-info class="po-md-3" p-label="Provisional Seal" [p-value]="romaneioCliente.CZ00SELOP"></po-info>
          <po-info class="po-md-3" p-label="Placa" [p-value]="romaneioCliente.CZ00PLACA"></po-info>
        </div>
      }
    </po-widget>
  </div>

  <h1 class="po-md-12 po-font-subtitle po-mb-1 po-mt-3">Pedidos Pendentes</h1>
  <div class="po-row">
    <div class="po-row">
      <po-input
        class="po-md-6"
        name="filtroItens"
        [(ngModel)]="filtroItens"
        p-label="Filtro"
        (p-change)="filtrarPedidos()"
      ></po-input>
      <po-select class="po-md-6"
        name="filtroStatus"
        p-label="Status"
        [(ngModel)]="filtroStatus"
        [p-options]="[
          {value: '', label: 'Todos'},
          {value: 'NV', label: 'Não Vinculados'},
        ]"
        (p-change)="filtrarPedidos()"
      ></po-select>
    </div>
    <po-table class="po-sm-12 po-md-12 po-lg-12"
      [p-striped]="true"
      [p-items]="pedidosFiltrados"
      [p-columns]="colunasPedidos"
      [p-sort]="true"
      [p-selectable]="romaneioCliente.CZ00STATUS == '0' || romaneioCliente.CZ00STATUS == '1'"
      (p-selected)="selectLinha($event)"
      (p-unselected)="selectLinha($event)"
      p-spacing="small"
    ></po-table>
    <po-button class="po-md-12 po-mt-2" p-type="default" p-label="Adicionar Itens ao Romaneio" (p-click)="adicionarItensRomaneio()" [p-disabled]="romaneioCliente.CZ00STATUS=='3' || romaneioCliente.CZ00STATUS=='Z'"></po-button>
  </div>
  <h1 class="po-md-12 po-font-subtitle po-mb-1 po-mt-3">Romaneios Selecionados</h1>
  <div class="po-row">
    <po-table class="po-sm-12 po-md-12 po-lg-12"
      [p-striped]="true"
      [p-items]="romaneioCliente.itemsSelecionados"
      [p-columns]="colunasSelecionados"
      p-spacing="small"
    ></po-table>
    <po-button class="po-md-12 po-mt-2" p-kind="secondary" p-label="Gerar Pedido Único" (p-click)="acaoGerarPedidoUnico()" [p-disabled]="podeAvancar"></po-button>
  </div>
</po-page-default>

<po-modal #alteraDadosModal p-title="Dados do Romaneio" [p-primary-action]="salvarDadosRomaneio">
  <form #f="ngForm">
    @if(alteraRomaneio.CZ00STATUS==='0'){
      <div>
        <po-divider class="po-md-12" p-label="1ª Etapa"></po-divider>
        <po-lookup
          class="po-md-6"
          name="CZ00CAMICP"
          [(ngModel)]="alteraRomaneio.CZ00CAMICP"
          p-field-label="CA4NOME"
          p-field-value="CA4COD"
          p-label="Truck Company / Transportadora"
          [p-columns]="columnsTransportadoraFilters"
          [p-field-format]="fieldFormaterTransportadoraFilters"
          [p-filter-service]="transportadoraService"
          [p-advanced-filters]="advancedTransportadoraFilters"
          [p-literals]="{ modalTitle: 'Transportadora' }"
        ></po-lookup>
        <po-input
          class="po-md-6"
          name="CZ00PROCES"
          [(ngModel)]="alteraRomaneio.CZ00PROCES"
          p-label="Process / Processo"
        ></po-input>
        <po-input
          class="po-md-6"
          name="CZ00NCERT"
          [(ngModel)]="alteraRomaneio.CZ00NCERT"
          p-label="Nº Certificado"
          [p-disabled]="true"
        ></po-input>
        <po-number
          class="po-md-6"
          name="NZ00PESLIM"
          [(ngModel)]="alteraRomaneio.NZ00PESLIM"
          p-label="Limit Weight / Peso Limite"
        ></po-number>
      </div>
    }
    @if(['1','2','3','4','5'].includes(alteraRomaneio.CZ00STATUS)){
      <div>
        <po-divider class="po-md-12" p-label="2ª Etapa"></po-divider>
        <po-lookup class="po-md-6"
          name="CZ00PLACA"
          p-label="Truck Plate / Placa Veículo"
          [(ngModel)]="alteraRomaneio.CZ00PLACA"
          p-field-value="CDA3PLACA"
          p-field-label="CDA3DESC"
          [p-columns]="veiculoColumnsFilters"
          [p-field-format]="veiculoFieldFormaterFilters"
          [p-filter-service]="veiculoLookupService"
          [p-advanced-filters]="veiculoAdvancedFilters"
          [p-literals]="{ modalTitle: 'Veículo' }"
          [p-required]="true"
          [p-disabled]="bloqueiaPlaca">
        </po-lookup>
        <po-input class="po-md-6"
          name="CZ00COTNER"
          p-label="Container / Container"
          [(ngModel)]="alteraRomaneio.CZ00COTNER">
        </po-input>
        <po-number class="po-md-6"
          name="NZ00TARA"
          p-label="Tare / Tara"
          [(ngModel)]="alteraRomaneio.NZ00TARA">
        </po-number>
        <po-input class="po-md-6"
          name="CZ00SELOD"
          p-label="Definitive Seal / Lacre Definitivo"
          [(ngModel)]="alteraRomaneio.CZ00SELOD">
        </po-input>
        <po-input class="po-md-6"
          name="CZ00SELOP"
          p-label="Provisional Seal / Lacre Provisório"
          [(ngModel)]="alteraRomaneio.CZ00SELOP">
        </po-input>
        <po-datepicker class="po-md-3"
          name="DZ00DATA"
          [(ngModel)]="alteraRomaneio.DZ00DTACAR"
          p-label="Data de Carregamento">
        </po-datepicker>
        <po-input class="po-md-3"
          name="CZ00HORA"
          [(ngModel)]="alteraRomaneio.CZ00HRACAR"
          p-mask="99:99:99"
          p-label="Hora do Carregamento">
        </po-input>
      </div>
    }
  </form>
</po-modal>

<po-modal #gerarPedidoModal p-title="Selecione o cliente a faturar" [p-primary-action]="gerarPedidoUnicoAction">
  <form #f="ngForm">
    <po-lookup
      class="po-md-12"
      name="codigoCliente"
      [(ngModel)]="codCliente"
      p-field-label="CA1NREDUZ"
      p-field-value="CA1COD"
      p-label="Cliente"
      [p-columns]="columnsClienteFilters"
      [p-field-format]="fieldFormaterClienteFilters"
      [p-filter-service]="clienteLookupService"
      [p-filter-params]="filterCliente"
      [p-advanced-filters]="advancedClienteFilters"
      [p-literals]="{ modalTitle: 'Cliente' }"
      (p-selected)="clienteSelecionado($event)"
    ></po-lookup>
  </form>
</po-modal>
